/**
 * TTB hero — parallax-style scroll on headline / CTA (desktop).
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var wrap = document.querySelector('.TTB_Wrap');
  if (!wrap) return;
  var content = wrap.querySelector('.TTB_Content');
  var btn = wrap.querySelector('.TTB_Btn');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var rect = wrap.getBoundingClientRect();
      var h = wrap.offsetHeight;
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        var scrolled = -rect.top;
        var ratio = Math.max(0, Math.min(scrolled / h, 1));
        var textShift = scrolled * 0.18;
        var fade = 1 - ratio * 0.6;
        if (content) content.style.transform = 'translateY(calc(-50% + ' + textShift + 'px))';
        if (btn) btn.style.opacity = isMobile ? '1' : String(fade);
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
